import React from 'react';
import Highcharts from 'highcharts/highcharts';
import HighchartsReact from 'highcharts-react-official';

import { InlineMath, BlockMath } from 'react-katex';
import 'katex/dist/katex.min.css';

import orig from './orig';
import kick from './kick';
import adj from './adj';

const base = {
  credits: {
    enabled: false
  },
  plotOptions: {
    series: {
      enableMouseTracking: false,
      lineWidth: 1,
      marker: { enabled: true }
    }
  },
}

const options1 = {
  ...base,
  yAxis: {
    title: { enabled: false },
    min: 8000,
    max: 16000,
    tickInterval: 1000
  },
  title: {
    text: 'Original',
    margin: 1,
    style: { fontSize: '12px' },
  },
  legend: {
    enabled: false,
  },
  series: [
    {
      data: orig,
      marker: { radius: 1.5 }
    }
  ]
};

const options2 = {
  ...base,
  yAxis: {
    title: { enabled: false },
    min: 9000,
    max: 14000,
    tickInterval: 1000
  },
  title: {
    text: 'Delta Kick',
    margin: 1,
    style: { fontSize: '12px' },
  },
  legend: {
    enabled: false,
  },
  series: [
    {
      data: kick,
      marker: { radius: 1.5 }
    }
  ]
};

const options3 = {
  ...base,
  yAxis: {
    title: { enabled: false },
    min: -0.2,
    max: 0.3,
    tickInterval: .1
  },
  title: {
    text: 'Rescaled',
    margin: 1,
    style: { fontSize: '12px' },
  },
  legend: {
    enabled: false,
  },
  series: [
    {
      data: adj,
      marker: { radius: 1.5 }
    }
  ]
};

const opts = { style: { height: '150px', width:'100%' }};

function Chaotic() {
  return (
    <div className="row">
      <div className="col-12">
        <h5 className="text-uppercase">Insulin-Glucose</h5>
        <div className="row">
          <div className="col-12 col-xxxl-6">
            <p>We expand the <strong>Ultradian model</strong> for glucose-insulin production with <strong>delta kicks</strong> for our chaotic series.</p>
            <p>Our nutritional driver <InlineMath>{` I_{G}(t) `}</InlineMath> includes basal signal and pulsatile kicks</p>
            <BlockMath>{` I_{G}(t) = I_{0} + \\displaystyle \\sum_{n=0}^{\\infty}A_{n}\\delta(t-T_{n}) `}</BlockMath>
            <p>
              We rescale the data by a factor of <InlineMath>{` 10^{-4} `}</InlineMath> and then shift by <InlineMath>-1.1</InlineMath> to avoid neuron saturation.
            </p>
          </div>
          <div className="col-12 col-xxxl-6">
            <BlockMath>
            {`
              \\begin{aligned}
                \\footnotesize \\frac{\\text{d}I_{p}}{\\text{d}t} &= f_{1}(G) - E \\left( \\frac{I_{p}}{V_{p}} - \\frac{I_{i}}{V_{i}} \\right) - \\frac{I_{p}}{t_{p}} \\\\
                \\footnotesize \\frac{\\text{d}I_{i}}{\\text{d}t} &= E \\left( \\frac{I_{p}}{V_{p}} - \\frac{I_{i}}{V_{i}} \\right) - \\frac{I_{i}}{t_{i}} \\\\
                \\footnotesize \\frac{\\text{d}G}{\\text{d}t} &= f_{4}(h_{3}) + I_{G}(t) - f_{2}(G) - f_{3}(I_{i})G \\\\
                \\footnotesize \\frac{\\text{d}h_{1}}{\\text{d}t} &= \\frac{1}{t_{d}}(I_{p}-h_{1}) \\\\
                \\footnotesize \\frac{\\text{d}h_{2}}{\\text{d}t} &= \\frac{1}{t_{d}}(h_{1}-h_{2}) \\\\
                \\footnotesize \\frac{\\text{d}h_{3}}{\\text{d}t} &= \\frac{1}{t_{d}}(h_{2}-h_{3})
              \\end{aligned}
            `}
            </BlockMath>
          </div>
        </div>
      </div>
      <div className="col-12">
      </div>
      <div className="col-12">
        <div className="row">
          <div className="col-12 col-xxxl-4">
            <HighchartsReact
              highcharts={Highcharts}
              options={options1}
              containerProps={opts}
            />
          </div>
          <div className="col-12 col-xxxl-4">
            <HighchartsReact
              highcharts={Highcharts}
              options={options2}
              containerProps={opts}
            />
          </div>
          <div className="col-12 col-xxxl-4">
            <HighchartsReact
              highcharts={Highcharts}
              options={options3}
              containerProps={opts}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Chaotic;
